"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var FireWallRuleEditor = /** @class */ (function (_super) {
    __extends(FireWallRuleEditor, _super);
    function FireWallRuleEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_additional2 = "additional2";
        return _this;
    }
    FireWallRuleEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_PP = this.props.listPProgramPartnersAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_pprogram_partners: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    is_locked: _item.is_locked,
                    description: _item.description,
                    is_control_ip: _item.is_control_ip,
                    ip_address: _item.ip_address,
                    is_control_fingerprint: _item.is_control_fingerprint,
                    fingerprint: _item.fingerprint,
                    is_control_useragent: _item.is_control_useragent,
                    useragent: _item.useragent,
                    is_control_email_part: _item.is_control_email_part,
                    email_part: _item.email_part,
                    on_detect_action_code: _item.on_detect_action_code,
                    on_detect_action_title: _item.on_detect_action_title,
                    firewall_event_code: _item.firewall_event_code,
                    firewall_event_title: _item.firewall_event_title,
                    is_control_partner: _item.is_control_partner,
                    pprogram_id: _item.pprogram_id,
                    pprogram_title: _item.pprogram_title,
                    usr_partner_id: _item.usr_partner_id,
                    usr_partner_title: _item.usr_partner_login,
                    on_detect_trust_zone_code: _item.on_detect_trust_zone_code,
                    on_detect_trust_zone_title: _item.on_detect_trust_zone_title,
                    on_detect_message_code: _item.on_detect_message_code,
                    on_detect_message_title: _item.on_detect_message_title,
                    is_control_suspicious_partners_only: _item.is_control_suspicious_partners_only,
                    is_control_isp_provider: _item.is_control_isp_provider,
                    isp_provider: _item.isp_provider,
                    is_control_password: _item.is_control_password,
                    password: _item.password,
                    is_control_timezone_offset: _item.is_control_timezone_offset,
                    timezone_offset: _item.timezone_offset,
                    is_control_specified_country_code: _item.is_control_specified_country_code,
                    specified_country_code: _item.specified_country_code,
                    is_control_except_the_specified_country_code: _item.is_control_except_the_specified_country_code,
                    except_the_specified_country_code: _item.except_the_specified_country_code,
                    is_player_login_equal_password: _item.is_player_login_equal_password,
                    avail_pprogram_partners: [],
                    tabKey: this.key_main
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование правила"]);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                is_locked: false,
                description: "",
                is_control_ip: false,
                ip_address: "",
                is_control_fingerprint: false,
                fingerprint: "",
                is_control_useragent: false,
                useragent: "",
                is_control_email_part: false,
                email_part: "",
                on_detect_action_code: 0,
                on_detect_action_title: "",
                firewall_event_code: 0,
                firewall_event_title: "",
                is_control_partner: false,
                pprogram_id: 0,
                pprogram_title: "",
                usr_partner_id: 0,
                usr_partner_title: "",
                on_detect_trust_zone_code: 0,
                on_detect_trust_zone_title: "",
                on_detect_message_code: 0,
                on_detect_message_title: "",
                is_control_suspicious_partners_only: false,
                is_control_isp_provider: false,
                isp_provider: "",
                is_control_password: false,
                password: "",
                is_control_timezone_offset: false,
                timezone_offset: 0,
                is_control_specified_country_code: false,
                specified_country_code: "",
                is_control_except_the_specified_country_code: false,
                except_the_specified_country_code: "",
                is_player_login_equal_password: false,
                avail_pprogram_partners: [],
                tabKey: this.key_main
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание правила"]);
            });
        }
        this.doReSetRules();
    };
    FireWallRuleEditor.prototype.componentWillUnmount = function () {
        this.props.listPProgramPartnersAvail.UnSubscribe(this.SID_PP);
    };
    FireWallRuleEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            fingerprint_rules: { isError: false },
            useragent_rules: { isError: false },
            on_detect_action_rules: { isError: false },
            email_part_rules: { isError: false },
            firewall_event_rules: { isError: false },
            pprogram_rules: { isError: false },
            usr_partner_rules: { isError: false },
            on_detect_trust_zone_rules: { isError: false },
            on_detect_message_rules: { isError: false },
            isp_provider_rules: { isError: false },
            password_rules: { isError: false },
            timezone_offset_rules: { isError: false },
            specified_country_code_rules: { isError: false },
            except_the_specified_country_code_rules: { isError: false },
        });
    };
    FireWallRuleEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [брэнд] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.on_detect_action_code <= 0) || (this.state.on_detect_action_title.length === 0)) {
            this.setState({
                on_detect_action_rules: { isError: true, errorMessage: "Поле [действие] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.state.is_control_ip) {
            if (this.state.ip_address.length == 0) {
                this.setState({
                    ip_address_rules: { isError: true, errorMessage: "Поле [ip адрес] не заполнено!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if (this.state.is_control_fingerprint) {
            if (this.state.fingerprint.length == 0) {
                this.setState({
                    fingerprint_rules: { isError: true, errorMessage: "Поле [отпечаток] не заполнено!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if (this.state.is_control_useragent) {
            if (this.state.useragent.length == 0) {
                this.setState({
                    useragent_rules: { isError: true, errorMessage: "Поле [юзерагент] не заполнено!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if (this.state.is_control_email_part) {
            if (this.state.email_part.length == 0) {
                this.setState({
                    email_part_rules: { isError: true, errorMessage: "Поле [часть email] не заполнено!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if (this.state.is_control_partner) {
            if ((this.state.usr_partner_id <= 0) || (this.state.usr_partner_title.length === 0)) {
                this.setState({
                    usr_partner_rules: { isError: true, errorMessage: "Поле [партнер] не выбрано!" },
                    tabKey: this.key_additional
                });
                return false;
            }
            if ((this.state.pprogram_id <= 0) || (this.state.pprogram_title.length === 0)) {
                this.setState({
                    pprogram_rules: { isError: true, errorMessage: "Поле [п.программа] не выбрано!" },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if ((this.state.firewall_event_code <= 0) || (this.state.firewall_event_title.length === 0)) {
            this.setState({
                firewall_event_rules: { isError: true, errorMessage: "Поле [событие] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.on_detect_trust_zone_code <= 0) || (this.state.on_detect_trust_zone_title.length === 0)) {
            this.setState({
                on_detect_trust_zone_rules: { isError: true, errorMessage: "Поле [зона доверия] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.on_detect_message_code <= 0) || (this.state.on_detect_message_title.length === 0)) {
            this.setState({
                on_detect_message_rules: { isError: true, errorMessage: "Поле [сообщение игроку] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.state.is_control_isp_provider) {
            if (this.state.isp_provider.length == 0) {
                this.setState({
                    isp_provider_rules: { isError: true, errorMessage: "Поле [интернет провайдер] не заполнено!" },
                    tabKey: this.key_additional2
                });
                return false;
            }
        }
        if (this.state.is_control_password) {
            if (this.state.password.length == 0) {
                this.setState({
                    password_rules: { isError: true, errorMessage: "Поле [пароль] не заполнено!" },
                    tabKey: this.key_additional2
                });
                return false;
            }
        }
        if (this.state.is_control_timezone_offset) {
            if (this.state.timezone_offset > 24) {
                this.setState({
                    timezone_offset_rules: { isError: true, errorMessage: "Поле [таймзона] заполнено некорректно!" },
                    tabKey: this.key_additional2
                });
                return false;
            }
        }
        if (this.state.is_control_specified_country_code) {
            if (this.state.specified_country_code.length == 0) {
                this.setState({
                    specified_country_code_rules: { isError: true, errorMessage: "Поле [выбранный код страны] не заполнено!" },
                    tabKey: this.key_additional2
                });
                return false;
            }
        }
        if (this.state.is_control_except_the_specified_country_code) {
            if (this.state.except_the_specified_country_code.length == 0) {
                this.setState({
                    except_the_specified_country_code_rules: { isError: true, errorMessage: "Поле [все, кроме выбранных кодов страны] не заполнено!" },
                    tabKey: this.key_additional2
                });
                return false;
            }
        }
        return true;
    };
    FireWallRuleEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                is_locked: this.state.is_locked,
                brand_id: this.state.brand_id,
                is_control_ip: this.state.is_control_ip,
                ip_address: this.state.ip_address,
                is_control_fingerprint: this.state.is_control_fingerprint,
                fingerprint: this.state.fingerprint,
                is_control_useragent: this.state.is_control_useragent,
                useragent: this.state.useragent,
                on_detect_action_code: this.state.on_detect_action_code,
                is_control_email_part: this.state.is_control_email_part,
                email_part: this.state.email_part,
                firewall_event_code: this.state.firewall_event_code,
                is_control_partner: this.state.is_control_partner,
                on_detect_message_code: this.state.on_detect_message_code,
                on_detect_trust_zone_code: this.state.on_detect_trust_zone_code,
                pprogram_id: this.state.pprogram_id,
                usr_partner_id: this.state.usr_partner_id,
                is_control_suspicious_partners_only: this.state.is_control_suspicious_partners_only,
                is_control_isp_provider: this.state.is_control_isp_provider,
                isp_provider: this.state.isp_provider,
                is_control_password: this.state.is_control_password,
                password: this.state.password,
                is_control_timezone_offset: this.state.is_control_timezone_offset,
                timezone_offset: this.state.timezone_offset,
                is_control_specified_country_code: this.state.is_control_specified_country_code,
                specified_country_code: this.state.specified_country_code,
                is_control_except_the_specified_country_code: this.state.is_control_except_the_specified_country_code,
                except_the_specified_country_code: this.state.except_the_specified_country_code,
                is_player_login_equal_password: this.state.is_player_login_equal_password
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Правило изменено!");
            });
        }
    };
    FireWallRuleEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                is_locked: this.state.is_locked,
                brand_id: this.state.brand_id,
                is_control_ip: this.state.is_control_ip,
                ip_address: this.state.ip_address,
                is_control_fingerprint: this.state.is_control_fingerprint,
                fingerprint: this.state.fingerprint,
                is_control_useragent: this.state.is_control_useragent,
                useragent: this.state.useragent,
                on_detect_action_code: this.state.on_detect_action_code,
                is_control_email_part: this.state.is_control_email_part,
                email_part: this.state.email_part,
                firewall_event_code: this.state.firewall_event_code,
                is_control_partner: this.state.is_control_partner,
                on_detect_message_code: this.state.on_detect_message_code,
                on_detect_trust_zone_code: this.state.on_detect_trust_zone_code,
                pprogram_id: this.state.pprogram_id,
                usr_partner_id: this.state.usr_partner_id,
                is_control_suspicious_partners_only: this.state.is_control_suspicious_partners_only,
                is_control_isp_provider: this.state.is_control_isp_provider,
                isp_provider: this.state.isp_provider,
                is_control_password: this.state.is_control_password,
                password: this.state.password,
                is_control_timezone_offset: this.state.is_control_timezone_offset,
                timezone_offset: this.state.timezone_offset,
                is_control_specified_country_code: this.state.is_control_specified_country_code,
                specified_country_code: this.state.specified_country_code,
                is_control_except_the_specified_country_code: this.state.is_control_except_the_specified_country_code,
                except_the_specified_country_code: this.state.except_the_specified_country_code,
                is_player_login_equal_password: this.state.is_player_login_equal_password
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Правило добавлено!");
            });
        }
    };
    FireWallRuleEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    FireWallRuleEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить правило";
        }
        else {
            return "Изменить правило";
        }
    };
    FireWallRuleEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    FireWallRuleEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.availBrands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите событие:", placeholder: "Выберите событие" }, value: { key: this.state.firewall_event_code, value: this.state.firewall_event_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        firewall_event_code: newVal.key,
                        firewall_event_title: newVal.value,
                        firewall_event_rules: { isError: false }
                    });
                }, items: this.props.avail_events, 
                // disabled={this.props.record != null}
                required: true, rules: this.state.firewall_event_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите действие:", placeholder: "Выберите действие" }, value: { key: this.state.on_detect_action_code, value: this.state.on_detect_action_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_detect_action_code: newVal.key,
                        on_detect_action_title: newVal.value,
                        on_detect_action_rules: { isError: false }
                    });
                }, items: this.props.availActions, required: true, rules: this.state.on_detect_action_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Зона доверия:", placeholder: "Выберите зону доверия" }, value: { key: this.state.on_detect_trust_zone_code, value: this.state.on_detect_trust_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_detect_trust_zone_code: newVal.key,
                        on_detect_trust_zone_title: newVal.value,
                        on_detect_trust_zone_rules: { isError: false }
                    });
                }, items: this.props.avail_trust_zones, required: true, rules: this.state.on_detect_trust_zone_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Сообщение игроку:", placeholder: "Выберите сообщение игроку" }, value: { key: this.state.on_detect_message_code, value: this.state.on_detect_message_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_detect_message_code: newVal.key,
                        on_detect_message_title: newVal.value,
                        on_detect_message_rules: { isError: false }
                    });
                }, items: this.props.avail_message_types, required: true, rules: this.state.on_detect_message_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Правило заблокировано", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    FireWallRuleEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать ip адрес", value: this.state.is_control_ip, onChecked: function (checked) {
                    _this.setState({
                        is_control_ip: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Ip адрес:", placeholder: "Введите Ip адрес" }, value: this.state.ip_address, onValueChanged: function (newVal) {
                    _this.setState({
                        ip_address: newVal,
                        ip_address_rules: { isError: false }
                    });
                }, required: this.state.is_control_ip, rules: this.state.ip_address_rules, disabled: !this.state.is_control_ip }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать отпечаток", value: this.state.is_control_fingerprint, onChecked: function (checked) {
                    _this.setState({
                        is_control_fingerprint: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Отпечаток:", placeholder: "Введите отпечаток" }, value: this.state.fingerprint, onValueChanged: function (newVal) {
                    _this.setState({
                        fingerprint: newVal,
                        fingerprint_rules: { isError: false }
                    });
                }, required: this.state.is_control_fingerprint, rules: this.state.fingerprint_rules, disabled: !this.state.is_control_fingerprint }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать юзерагент", value: this.state.is_control_useragent, onChecked: function (checked) {
                    _this.setState({
                        is_control_useragent: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Юзерагент:", placeholder: "Введите юзерагент" }, value: this.state.useragent, onValueChanged: function (newVal) {
                    _this.setState({
                        useragent: newVal,
                        useragent_rules: { isError: false }
                    });
                }, required: this.state.is_control_useragent, rules: this.state.useragent_rules, disabled: !this.state.is_control_useragent }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать часть почты", value: this.state.is_control_email_part, onChecked: function (checked) {
                    _this.setState({
                        is_control_email_part: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Часть почты:", placeholder: "Введите часть почты" }, value: this.state.email_part, onValueChanged: function (newVal) {
                    _this.setState({
                        email_part: newVal,
                        email_part_rules: { isError: false }
                    });
                }, required: this.state.is_control_email_part, rules: this.state.email_part_rules, disabled: !this.state.is_control_email_part }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать партнера", value: this.state.is_control_partner, onChecked: function (checked) {
                    _this.setState({
                        is_control_partner: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_id: newVal.key,
                        pprogram_title: newVal.value,
                        pprogram_rules: { isError: false }
                    }, function () {
                        _this.props.listPProgramPartnersAvail.LoadData(_this.state.pprogram_id);
                    });
                }, items: this.props.avail_pprograms, required: true, rules: this.state.pprogram_rules, disabled: !this.state.is_control_partner }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Партнер:", placeholder: "Выберите партнера" }, value: { key: this.state.usr_partner_id, value: this.state.usr_partner_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        usr_partner_id: newVal.key,
                        usr_partner_title: newVal.value,
                        usr_partner_rules: { isError: false }
                    });
                }, items: this.state.avail_pprogram_partners, required: true, rules: this.state.usr_partner_rules, disabled: !this.state.is_control_partner }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать партнеров с подозрительным трафиком", value: this.state.is_control_suspicious_partners_only, onChecked: function (checked) {
                    _this.setState({
                        is_control_suspicious_partners_only: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    FireWallRuleEditor.prototype.getAdditional2EditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать интернет-провайдера", value: this.state.is_control_isp_provider, onChecked: function (checked) {
                    _this.setState({
                        is_control_isp_provider: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Интернет-провайдер:", placeholder: "Введите название интернет-провайдера" }, value: this.state.isp_provider, onValueChanged: function (newVal) {
                    _this.setState({
                        isp_provider: newVal,
                        isp_provider_rules: { isError: false }
                    });
                }, disabled: !this.state.is_control_isp_provider, required: !this.state.is_control_isp_provider, rules: this.state.isp_provider_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать пароль", value: this.state.is_control_password, onChecked: function (checked) {
                    _this.setState({
                        is_control_password: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Пароль:", placeholder: "Введите пароль" }, value: this.state.password, onValueChanged: function (newVal) {
                    _this.setState({
                        password: newVal,
                        password_rules: { isError: false }
                    });
                }, disabled: !this.state.is_control_password, required: !this.state.is_control_password, rules: this.state.password_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Логин совпадает с паролем", value: this.state.is_player_login_equal_password, onChecked: function (checked) {
                    _this.setState({
                        is_player_login_equal_password: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать таймзону", value: this.state.is_control_timezone_offset, onChecked: function (checked) {
                    _this.setState({
                        is_control_timezone_offset: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Таймзона:",
                    placeholder: "Введите значение таймзоны"
                }, values: {
                    max: 24,
                    min: 0,
                    value: this.state.timezone_offset
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        timezone_offset: newVal,
                        timezone_offset_rules: { isError: false }
                    });
                }, required: !this.state.is_control_timezone_offset, disabled: !this.state.is_control_timezone_offset, rules: this.state.timezone_offset_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать указанные коды стран", value: this.state.is_control_specified_country_code, onChecked: function (checked) {
                    _this.setState({
                        is_control_specified_country_code: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Коды стран:", placeholder: "Введите значения кодов стран" }, value: this.state.specified_country_code, onValueChanged: function (newVal) {
                    _this.setState({
                        specified_country_code: newVal,
                        specified_country_code_rules: { isError: false }
                    });
                }, disabled: !this.state.is_control_specified_country_code, required: !this.state.is_control_specified_country_code, rules: this.state.specified_country_code_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать коды стран кроме указанных", value: this.state.is_control_except_the_specified_country_code, onChecked: function (checked) {
                    _this.setState({
                        is_control_except_the_specified_country_code: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Коды стран:", placeholder: "Введите значения кодов стран" }, value: this.state.except_the_specified_country_code, onValueChanged: function (newVal) {
                    _this.setState({
                        except_the_specified_country_code: newVal,
                        except_the_specified_country_code_rules: { isError: false }
                    });
                }, disabled: !this.state.is_control_except_the_specified_country_code, required: !this.state.is_control_except_the_specified_country_code, rules: this.state.except_the_specified_country_code_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    FireWallRuleEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        if (this.state.tabKey === this.key_additional2) {
            return this.getAdditional2EditContent();
        }
        throw "invalid tabkey -> " + this.state.tabKey;
    };
    FireWallRuleEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 800, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
                { key: this.key_additional2, tab: "Дополнительно2" }
            ], onTabChange: function (key) { _this.onTabChange(key); }, activeTabKey: this.state.tabKey }, this.getContent()));
    };
    return FireWallRuleEditor;
}(React.Component));
exports.default = FireWallRuleEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/security_firewall/ui/component/FireWallRuleEditor.tsx
// module id = 2550
// module chunks = 0